/*
 * Lightweight utility for keeping track of a sequence of scans
 */
import { AxiosResponse } from 'axios'

interface ScanResult {
  ident: string
  response?: AxiosResponse
}

export class ScanLog {
  scans: ScanResult[]

  constructor() {
    this.scans = []
  }

  log(ident: string, response?: AxiosResponse) {
    this.scans.push({ ident, response })
  }
}
